import React, {useState, useEffect} from "react";
import { createPost } from "../../services/NewsEventSpeech";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

const CreatePostForm = () => {
    const { quill, quillRef } = useQuill({
        theme: "snow",
    });

    const [form, setForm] = useState({
        title: "",
        description: "",
        type: "",
        event_date: "",
        video_url: "",
    });

    // alert()

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    useEffect(() => {
        if (quill) {
            quill.on("text-change", () => {
                setForm({ ...form, description: quill.root.innerHTML });
            });
        }
    }, [quill]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await createPost(form);
        setMessage(res.success ? "Post created successfully!" : res.message);
        setLoading(false);
    };

    const extractYouTubeID = (url) => {
        const match = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})(?:\?|&|$)/);
        return match ? match[1] : null;
    };

    return (
        <div className=" mx-auto mt-10 bg-white dark:bg-gray-800 shadow-md rounded-xl p-8">
            <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-white">Create New Post</h2>

            {message && (
                <div className="mb-4 p-3 text-sm rounded bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                    {message}
                </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Type</label>
                    <select
                        name="type"
                        value={form.type}
                        className="w-full border px-4 py-2 rounded-md bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select type</option>
                        <option value="news">News</option>
                        <option value="event">Event</option>
                        <option value="speech">Speech</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Title</label>
                    <input
                        type="text"
                        name="title"
                        value={form.title}
                        className="w-full border px-4 py-2 rounded-md bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Description</label>
                    <div ref={quillRef} className="bg-white dark:bg-gray-700 dark:text-white"></div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Event Date</label>
                    <input
                        type="date"
                        name="event_date"
                        value={form.event_date}
                        className="w-full border px-4 py-2 rounded-md bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Video URL (optional)</label>
                    <input
                        type="url"
                        name="video_url"
                        value={form.video_url}
                        placeholder="https://youtu.be/pIVx6ia_t4E"
                        className="w-full border px-4 py-2 rounded-md bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        onChange={handleChange}
                    />

                    {form.video_url && (
                        <div className="mt-4 rounded overflow-hidden shadow-md">
                            {extractYouTubeID(form.video_url) ? (
                                <iframe
                                    src={`https://www.youtube.com/embed/${extractYouTubeID(form.video_url)}`}
                                    frameBorder="0"
                                    allowFullScreen
                                    width="100%"
                                    height="200"
                                    className="rounded"
                                ></iframe>
                            ) : form.video_url.includes("vimeo.com") ? (
                                <iframe
                                    src={`https://player.vimeo.com/video/${form.video_url.split("/").pop()}`}
                                    frameBorder="0"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                    width="100%"
                                    height="200"
                                    className="rounded"
                                ></iframe>
                            ) : form.video_url.match(/\.(mp4|webm|ogg)$/) ? (
                                <video controls width="100%" height="200" className="rounded bg-black">
                                    <source src={form.video_url} />
                                    Your browser does not support the video tag.
                                </video>
                            ) : (
                                <p className="text-sm text-red-500">Unsupported video format or platform</p>
                            )}
                        </div>
                    )}
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition duration-300"
                >
                    {loading ? "Creating..." : "Create Post"}
                </button>
            </form>

            {loading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="loader">Loading...</div>
                </div>
            )}
        </div>
    );
};

export default CreatePostForm;